/* Breadcrumbs.tsx generated by @compiled/babel-plugin v0.26.0 */
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["textColor"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import BreadcrumbsOriginal, { BreadcrumbsItem } from '@atlaskit/breadcrumbs';
import React from 'react';
import { charlieTextFontFamily } from '../FontFamily';
const _7 = "._13t31tcg span{line-height:24px}";
const _6 = "._nzz5oxwj span{font-size:.875rem}";
const _5 = "._1kd31nn1 span{font-weight:400}";
const _4 = "._1uq94jg8 span{font-style:normal}";
const _3 = "._1tjqgfg7 span{color:var(--_93wphf)}";
const _2 = "._ij3o1sdi span{font-family:Charlie Text,-apple-system,BlinkMacSystemFont,\"Segoe UI\",\"Roboto\",\"Oxygen\",\"Ubuntu\",\"Fira Sans\",\"Droid Sans\",\"Helvetica Neue\",sans-serif}";
const _ = "._1dzo18uv :after, ._gxv518uv :before{box-sizing:initial}";
const BreadcrumbsWrapper = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  const {
      textColor
    } = __cmplp,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded2);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3, _4, _5, _6, _7]), /*#__PURE__*/React.createElement(C, _extends({}, __cmpldp, {
    style: _objectSpread(_objectSpread({}, __cmpls), {}, {
      "--_93wphf": ix(__cmplp.textColor || "var(--ds-text-subtle)")
    }),
    ref: __cmplr,
    className: ax(["_1dzo18uv _gxv518uv _ij3o1sdi _1tjqgfg7 _1uq94jg8 _1kd31nn1 _nzz5oxwj _13t31tcg", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  BreadcrumbsWrapper.displayName = 'BreadcrumbsWrapper';
}
export const Breadcrumbs = props => {
  return /*#__PURE__*/React.createElement(BreadcrumbsWrapper, {
    textColor: props.textColor,
    className: props.className
  }, /*#__PURE__*/React.createElement(BreadcrumbsOriginal, props));
};
export { BreadcrumbsItem };